import queryKeys from '@/constants/queryKeys';
import { getSearchOrganizations } from '@/services/api/requests/super-admin';
import { useQuery } from '@tanstack/react-query';

const useSearchOrganizations = (search: string, enabled: boolean) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [queryKeys.superAdmin.searchOrganizations, search],
    queryFn: () => getSearchOrganizations(search),
    enabled: enabled && search.length > 0, // prevent unnecessary requests
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export default useSearchOrganizations;
